function getEnv(key, defaultValue = '') {
  const value = window?.custom_env && window?.custom_env[key];
  return value === undefined ? defaultValue : value;
}

function getBooleanEnv(key, defaultValue = false) {
  const value = getEnv(key, undefined);

  if (typeof value === 'boolean') {
    return value;
  }

  return value === '' ? defaultValue : value.toLowerCase() === 'true';
}

export const USE_BUREAUCRAT_MOCK = getBooleanEnv('USE_BUREAUCRAT_MOCK');
export const TRIALS_ENABLED = getBooleanEnv('ENABLE_TRIALS');
export const ENABLE_LOG_BOOK_KEEPING = getBooleanEnv(
  'ENABLE_LOG_BOOK_KEEPING',
  true,
);

export const BUREAUCRAT_BASE_URI =
  getEnv('BUREAUCRAT_BASE_URI') && !USE_BUREAUCRAT_MOCK
    ? getEnv('BUREAUCRAT_BASE_URI').replace(/\/$/, '')
    : '';

export const DEPLOYMENT = getEnv('DEPLOYMENT', 'local');
export const DEPLOYMENT_TYPE = getEnv('DEPLOYMENT_TYPE', 'dev');
const VERSION = getEnv('VERSION');

let logger = null;
let consoleLogger = null;
export const initializeConfig = (configLogger, consoleLoggerIn) => {
  logger = configLogger;
  consoleLogger = consoleLoggerIn;
};

export const verifyConfig = () => {
  if (
    process.env.NODE_ENV === 'development' &&
    !USE_BUREAUCRAT_MOCK &&
    !BUREAUCRAT_BASE_URI
  ) {
    consoleLogger.debug(
      "WARNING: The mock server isn't running and BUREAUCRAT_BASE_URI was not specified",
    );
  }
};

const logConfigUsingLogger = (theLogger) => {
  if (process.env.NODE_ENV === 'development') {
    theLogger.info(`USE_BUREAUCRAT_MOCK = ${USE_BUREAUCRAT_MOCK}`);
  }
  theLogger.info(`BUREAUCRAT_BASE_URI = ${BUREAUCRAT_BASE_URI}`);
  theLogger.info(`DEPLOYMENT = ${DEPLOYMENT}`);
  theLogger.info(`DEPLOYMENT_TYPE = ${DEPLOYMENT_TYPE}`);
  theLogger.info(`VERSION = ${VERSION}`);
  theLogger.info(`TRIALS_ENABLED = ${TRIALS_ENABLED}`);
  theLogger.info(`ENABLE_LOG_BOOK_KEEPING = ${ENABLE_LOG_BOOK_KEEPING}`);
};

export const logConfig = () => {
  logConfigUsingLogger(logger);
  // in prod we don't log to the console by default
  // log the version directly to the console in this case
  if (DEPLOYMENT_TYPE === 'prod') {
    consoleLogger.info(`VERSION = ${VERSION}`);
  }
};
